function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 16H12.1c-1.3 0-2.3 1-2.3 2.3v13.9c0 1.3 1 2.3 2.3 2.3h24.8c1.3 0 2.3-1 2.3-2.3V18.3c0-1.3-1.1-2.3-2.4-2.3zm0 1.5h.1l-11.7 7.8c-.4.3-1.3.3-1.7 0l-11.7-7.8h25zm0 15.5H12.1c-.4 0-.8-.3-.8-.8V19l11.4 7.6c.5.3 1.1.5 1.7.5s1.2-.2 1.7-.5L37.6 19v13.3c0 .4-.3.7-.8.7z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgEnvelope;